import { render, staticRenderFns } from "./project_supervision.vue?vue&type=template&id=a1a71cd8&scoped=true&"
import script from "./project_supervision.vue?vue&type=script&lang=js&"
export * from "./project_supervision.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1a71cd8",
  null
  
)

export default component.exports